import { useState, useRef, useEffect } from "react";
import { Icon } from "@components/index";
import "./index.scss";

const ClaimActionDropdown = ({ claim, onActionClick, isButtonClickable }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggleDropdown = (event) => {
    event.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleActionClick = (action) => {
    onActionClick(claim, action);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="claim-action-dropdown">
      <Icon
        iconName="threeDots"
        onClick={handleToggleDropdown}
        title="Handle Action"
        className={`claims-table__action-icon  ${
          isButtonClickable ? "" : "claims-table__action-icon-disabled"
        }`}
        width={18}
      />

      {isOpen && (
        <div ref={dropdownRef} className="claim-action-dropdown__menu">
          <button
            className="claim-action-dropdown__item claim-action-dropdown__item--approve"
            onClick={() => handleActionClick("approve")}
          >
            <Icon iconName="approvalIcon" className="dropdown-icon" />
            Approve
          </button>
          <button
            className="claim-action-dropdown__item claim-action-dropdown__item--reject"
            onClick={() => handleActionClick("reject")}
          >
            <Icon iconName="rejectIcon" className="dropdown-icon" />
            Reject
          </button>
        </div>
      )}
    </div>
  );
};

export default ClaimActionDropdown;
